module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/pageBannerSmall-651324c9d17821876f3831603a593bfd.png";